var _style, _path, _path2, _defs, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _g, _polygon, _polygon2, _polygon3, _polygon4, _polygon5, _path12, _path13, _path14, _path15, _g2, _polygon6, _path16, _polygon7, _polygon8, _polygon9, _polygon10, _polygon11, _polygon12, _polygon13, _polygon14, _g3, _polygon15, _polygon16, _polygon17, _polygon18, _g4, _polygon19, _polygon20, _polygon21, _polygon22, _polygon23, _polygon24, _polygon25, _polygon26, _polygon27, _polygon28, _g5, _g6, _g7, _defs2, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _path27, _path28, _path29, _path30, _path31, _path32, _path33, _path34, _path35, _path36, _path37, _g8, _g9, _polygon29, _polygon30, _polygon31, _polygon32, _polygon33, _polygon34, _polygon35, _g10, _g11, _g12, _g13, _g14, _g15, _g16, _g17, _g18, _g19, _polygon36, _polygon37, _g20, _g21, _g22, _g23, _g24, _g25, _polygon38, _polygon39;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgHome(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "\\u5716\\u5C64_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 125.9 109.6",
    style: {
      enableBackground: "new 0 0 125.9 109.6"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\r\n\t.st0{fill:#B6B7A2;}\r\n\t.st1{fill:#CCC6BA;}\r\n\t.st2{enable-background:new    ;}\r\n\t.st3{clip-path:url(#SVGID_00000125597351180679722180000015878901293282112676_);enable-background:new    ;}\r\n\t.st4{fill:#CACACA;}\r\n\t.st5{fill:#D9D9D9;}\r\n\t.st6{clip-path:url(#SVGID_00000125597351180679722180000015878901293282112676_);}\r\n\t.st7{fill:#F2F2F2;}\r\n\t.st8{fill:#FFF9E9;}\r\n\t.st9{fill:url(#SVGID_00000098899586644445988260000009396983384056533890_);}\r\n\t.st10{fill:url(#SVGID_00000058566173136491162760000003787194589220072068_);}\r\n\t.st11{fill:url(#SVGID_00000160155073503570175610000005700552631000350649_);}\r\n\t.st12{fill:url(#SVGID_00000181066696441527697760000003422789563800548744_);}\r\n\t.st13{fill:url(#SVGID_00000127026580396003104160000017817926317845940907_);}\r\n\t.st14{fill:url(#SVGID_00000092415992394660656590000013274249267022225040_);}\r\n\t.st15{fill:#2E2E37;}\r\n\t.st16{fill:#E4E6F0;}\r\n\t.st17{fill:url(#SVGID_00000065070746805585265470000017466859527351816082_);}\r\n\t.st18{fill:#585C73;}\r\n\t.st19{fill:#848AA8;}\r\n\t.st20{fill:#F1F3F9;}\r\n\t.st21{fill:url(#SVGID_00000119078607125197435920000004517921372526245515_);}\r\n\t.st22{fill:url(#SVGID_00000170978344890464072750000004335701360052587398_);}\r\n\t.st23{fill:#D8C79D;}\r\n\t.st24{fill:url(#SVGID_00000168834537103446010350000013674150083232572821_);}\r\n\t.st25{fill:url(#SVGID_00000145740039666211691030000013076252081044863872_);}\r\n\t.st26{fill:url(#SVGID_00000174603760447286322290000001386150657525047214_);}\r\n\t.st27{fill:url(#SVGID_00000046302563119035005390000006694527028711092406_);}\r\n\t.st28{fill:url(#SVGID_00000008861534173045664960000003657621802675011248_);}\r\n\t.st29{fill:#00678E;}\r\n\t.st30{fill:url(#SVGID_00000057866538347530016090000010699880732093384064_);}\r\n\t.st31{fill:#00729D;}\r\n\t.st32{fill:url(#SVGID_00000087372717328172021170000015785732478817249436_);}\r\n\t.st33{fill:url(#SVGID_00000026148988267343707750000018173586085365116034_);}\r\n\t.st34{fill:url(#SVGID_00000088098307500506884440000010115135418971871656_);}\r\n\t.st35{fill:#242A31;}\r\n\t.st36{fill:url(#SVGID_00000091716989088893509450000012135254495321666688_);}\r\n\t.st37{fill:url(#SVGID_00000154403106061242711680000014097122974034776733_);}\r\n\t.st38{fill:#C2C6D7;}\r\n\t.st39{fill:url(#SVGID_00000137104918282915897430000018018903026739095681_);}\r\n\t.st40{fill:url(#SVGID_00000183248683652778294600000013098799203983031953_);}\r\n\t.st41{fill:url(#SVGID_00000141454667343579116390000007283305578800361131_);}\r\n\t.st42{fill:url(#SVGID_00000125603945472600895350000017147341479294659992_);}\r\n\t.st43{fill:url(#SVGID_00000182486913063539293550000007480294511884976779_);}\r\n\t.st44{fill:url(#SVGID_00000047027248431012806530000005404518132469221281_);}\r\n\t.st45{fill:url(#SVGID_00000169523036233966940190000012421459003296965305_);}\r\n\t.st46{fill:#D8DFE9;}\r\n\t.st47{fill:#FFFFFF;}\r\n\t.st48{fill:#A4A9C2;}\r\n\t.st49{clip-path:url(#SVGID_00000160172899984463463930000005372336461561787306_);enable-background:new    ;}\r\n\t.st50{clip-path:url(#SVGID_00000160172899984463463930000005372336461561787306_);}\r\n\t.st51{fill:#AC312E;}\r\n\t.st52{fill:#EC534F;}\r\n\t.st53{fill:#F5F6F7;}\r\n\t.st54{fill:#35353F;}\r\n\t.st55{fill:url(#SVGID_00000102523032601516131160000016408248199225713312_);}\r\n\t.st56{fill:url(#SVGID_00000035523955412314644920000011465053381099632552_);}\r\n\t.st57{fill:url(#SVGID_00000013181542351670579120000007795698759492949423_);}\r\n\t.st58{fill:url(#SVGID_00000031907944881087127890000003028872632943184824_);}\r\n\t.st59{fill:url(#SVGID_00000054961817524253941820000002226976861189889704_);}\r\n\t.st60{fill:url(#SVGID_00000062908421993242617540000007066107233584020358_);}\r\n\t.st61{fill:url(#SVGID_00000140016447425186711560000000689335350980115869_);}\r\n\t.st62{fill:url(#SVGID_00000041987678877050501120000011708313894527281565_);}\r\n\t.st63{fill:url(#SVGID_00000050656010692720419030000013860385980010323634_);}\r\n\t.st64{fill:url(#SVGID_00000153694942006359850230000008557460822171492265_);}\r\n\t.st65{fill:#7A7F99;}\r\n\t.st66{fill:url(#SVGID_00000124859853075542433640000002067795369693140395_);}\r\n\t.st67{fill:url(#SVGID_00000085952027601667140450000005268081849803767445_);}\r\n\t.st68{fill:url(#SVGID_00000090269057555454407270000002976501441267483802_);}\r\n\t.st69{fill:url(#SVGID_00000151506464698266812730000006216080267513217686_);}\r\n\t.st70{fill:url(#SVGID_00000130631155529681675660000008516160333123618478_);}\r\n\t.st71{fill:url(#SVGID_00000047779983201673898870000006909003401090859427_);}\r\n\t.st72{fill:url(#SVGID_00000075851993761986914060000000342535788783520419_);}\r\n\t.st73{fill:url(#SVGID_00000027578696534688132750000017693763848247105164_);}\r\n\t.st74{fill:#FDDA4C;}\r\n\t.st75{fill:#38373E;}\r\n\t.st76{fill:url(#SVGID_00000178919057205886855640000006000695264029827764_);}\r\n")), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M125.9,70.6v-0.8L0,77.1l0,0.6l55.2,31.8L125.9,70.6z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M125.9,69.8L70.7,38.1L0,77.1l55.2,31.7L125.9,69.8z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", {
    className: "st2"
  }, /*#__PURE__*/React.createElement("g", {
    className: "st2"
  }, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "SVGID_1_",
    className: "st2",
    d: "M80,8.1l0.4,52c0,0.4-0.3,0.8-0.8,1.1c-1,0.6-2.6,0.6-3.7,0c-0.5-0.3-0.8-0.7-0.8-1.1l0.7-52 c0,0.3,0.2,0.6,0.6,0.9c0.8,0.5,2.1,0.5,2.9,0C79.8,8.7,80,8.4,80,8.1z"
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000048488759055365134470000018152895031955412898_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_1_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#SVGID_00000048488759055365134470000018152895031955412898_)",
      enableBackground: "new"
    }
  }, _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M80,8.1l0.4,52c0,0.4-0.3,0.8-0.8,1.1c-0.1,0.1-0.2,0.1-0.3,0.2L79.1,9.1C79.2,9,79.3,9,79.4,9 C79.8,8.7,80,8.4,80,8.1L80,8.1z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M79.1,9.1l0.2,52.2c-0.4,0.2-0.8,0.3-1.2,0.3l0.1-52.3C78.5,9.3,78.8,9.2,79.1,9.1L79.1,9.1z"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M76.9,9.2l-0.4,52.3c-0.2-0.1-0.4-0.1-0.6-0.3c-0.2-0.1-0.3-0.2-0.4-0.3l0.6-52.2c0.1,0.1,0.2,0.2,0.3,0.2 C76.6,9,76.8,9.1,76.9,9.2L76.9,9.2z"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M76.1,8.7l-0.6,52.2c-0.2-0.2-0.4-0.5-0.4-0.8l0.7-52C75.9,8.3,75.9,8.5,76.1,8.7L76.1,8.7z"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#SVGID_00000048488759055365134470000018152895031955412898_)"
    }
  }, _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    className: "st7",
    d: "M76.9,15.1l0,1.1c0.4,0.1,0.8,0.2,1.3,0.1l0-1.1C77.7,15.3,77.3,15.2,76.9,15.1z"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    className: "st7",
    d: "M76.9,18.3l-0.3,43.1c0.5,0.2,1,0.2,1.5,0.2l0.1-43.1C77.7,18.5,77.2,18.5,76.9,18.3z"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    className: "st7",
    d: "M78.1,10.9l0-1.6c-0.4,0-0.8,0-1.2-0.1l0,1.6C77.3,10.9,77.7,10.9,78.1,10.9z"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    className: "st7",
    d: "M78.1,15.3l0-4.4c-0.4,0-0.9,0-1.2-0.1l0,4.4C77.3,15.2,77.7,15.3,78.1,15.3z"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    className: "st7",
    d: "M76.9,16.2l0,2.2c0.4,0.1,0.8,0.2,1.3,0.2l0-2.2C77.7,16.3,77.3,16.3,76.9,16.2z"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st8",
    d: "M79.4,7.3c0.8,0.5,0.8,1.2,0,1.7c-0.8,0.5-2.1,0.5-2.9,0c-0.8-0.5-0.8-1.2,0-1.7C77.3,6.8,78.6,6.8,79.4,7.3 z"
  }))))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000167354618894742250440000001020058648174533029_",
    gradientUnits: "userSpaceOnUse",
    x1: 68.2305,
    y1: 55.8049,
    x2: 91.8577,
    y2: 55.8049
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#AEA388"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6,
    style: {
      stopColor: "#CDC3AB"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#E4DBC6"
    }
  })), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "url(#SVGID_00000167354618894742250440000001020058648174533029_)"
    },
    points: "91.9,66.7 68.2,80.3 68.2,44.9  91.9,31.3  "
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000001637147432263326630000010079737403999728774_",
    gradientUnits: "userSpaceOnUse",
    x1: 53.0658,
    y1: 50.8167,
    x2: 68.2305,
    y2: 50.8167
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#AEA388"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6,
    style: {
      stopColor: "#CDC3AB"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#E4DBC6"
    }
  })), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "url(#SVGID_00000001637147432263326630000010079737403999728774_)"
    },
    points: "58.6,32.7 68.2,38.3 68.2,30  53.1,21.3 53.1,56.8 68.2,80.3 68.2,44.9 57.6,38.8 57.6,33.2  "
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000164513472411936621890000014225990462609648828_",
    gradientUnits: "userSpaceOnUse",
    x1: 50.317,
    y1: 38.0426,
    x2: 53.0658,
    y2: 38.0426
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#AEA388"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6,
    style: {
      stopColor: "#CDC3AB"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#E4DBC6"
    }
  })), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "url(#SVGID_00000164513472411936621890000014225990462609648828_)"
    },
    points: "53.1,56.8 50.3,58.4 50.3,19.3  53.1,17.7 53.1,18.4 53.1,21.3  "
  }), _polygon || (_polygon = /*#__PURE__*/React.createElement("polygon", {
    className: "st8",
    points: "42.6,14.8 42.6,15.2 42.6,50.7 42.6,53.9 50.3,58.4 50.3,19.3  "
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000123420825020757133290000001664894965837064365_",
    gradientUnits: "userSpaceOnUse",
    x1: 41.3031,
    y1: 32.6188,
    x2: 42.55,
    y2: 32.6188
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#AEA388"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6,
    style: {
      stopColor: "#CDC3AB"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#E4DBC6"
    }
  })), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "url(#SVGID_00000123420825020757133290000001664894965837064365_)"
    },
    points: "42.5,50.7 41.3,50 41.3,14.5  42.5,15.2  "
  }), _polygon2 || (_polygon2 = /*#__PURE__*/React.createElement("polygon", {
    className: "st8",
    points: "42.5,15.2 41.3,14.5 44.3,12.7 45.4,12.1 47,11.2 51.5,8.6 52.6,8 54.3,7 58.2,4.7 59.3,4.1 61.1,3.1  64.9,0.9 91.9,16.4 68.2,30 53.1,21.3 53.1,18.4 68.2,27.2 85.8,17.1 86.9,16.4 64.9,3.7 46.9,14.1 45.3,13.2 42.5,14.8  "
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000044173426472276778940000013804821544934509205_",
    gradientUnits: "userSpaceOnUse",
    x1: 68.2305,
    y1: 27.3344,
    x2: 91.8577,
    y2: 27.3344
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#AEA388"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6,
    style: {
      stopColor: "#CDC3AB"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#E4DBC6"
    }
  })), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "url(#SVGID_00000044173426472276778940000013804821544934509205_)"
    },
    points: "68.2,30 68.2,38.3 91.9,24.6  91.9,16.4  "
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000111162547896655321030000015367370567479363493_",
    gradientUnits: "userSpaceOnUse",
    x1: 89.7481,
    y1: 20.97,
    x2: 90.2634,
    y2: 20.97
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#AEA388"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6,
    style: {
      stopColor: "#CDC3AB"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#E4DBC6"
    }
  })), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "url(#SVGID_00000111162547896655321030000015367370567479363493_)"
    },
    points: "89.7,21.2 89.7,20.7 90.3,20.4  90.3,21.5  "
  }), _polygon3 || (_polygon3 = /*#__PURE__*/React.createElement("polygon", {
    className: "st15",
    points: "89.7,20.7 89.7,21.2 87.1,22.8 87.1,22.2  "
  })), _polygon4 || (_polygon4 = /*#__PURE__*/React.createElement("polygon", {
    className: "st16",
    points: "87.1,22.8 89.7,21.2 90.3,21.5 87.1,23.4  "
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000007417085996976115320000015069422540139467704_",
    gradientUnits: "userSpaceOnUse",
    x1: 86.2824,
    y1: 22.8221,
    x2: 86.7978,
    y2: 22.8221
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#AEA388"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6,
    style: {
      stopColor: "#CDC3AB"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#E4DBC6"
    }
  })), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "url(#SVGID_00000007417085996976115320000015069422540139467704_)"
    },
    points: "86.3,23.6 86.3,21.7 86.8,22  86.8,23.9  "
  }), _polygon5 || (_polygon5 = /*#__PURE__*/React.createElement("polygon", {
    className: "st16",
    points: "86.3,21.7 90.1,19.5 90.6,19.8 86.8,22  "
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    className: "st18",
    d: "M90.6,19.8v1.9l-3.8,2.2V22L90.6,19.8z M90.3,21.5v-1.1l-0.5,0.3l-2.6,1.5v0.5v0.6L90.3,21.5z"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    className: "st19",
    d: "M86.8,22v1.9V22z"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    className: "st19",
    d: "M86.3,21.7l0.5,0.3L86.3,21.7z"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    className: "st16",
    d: "M90.6,19.8L86.8,22L90.6,19.8z"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "st19",
    points: "63.6,30.5 63.6,30 63.1,29.7 63.1,30.8  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st15",
    points: "63.6,30 63.6,30.5 66.2,32 66.2,31.5  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st20",
    points: "66.2,32 63.6,30.5 63.1,30.8 66.2,32.6  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st19",
    points: "67.1,32.9 67.1,31 66.6,31.3 66.6,33.2  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st20",
    points: "67.1,31 63.3,28.8 62.8,29.1 66.6,31.3  "
  }), /*#__PURE__*/React.createElement("path", {
    className: "st16",
    d: "M66.6,31.3v1.9L62.8,31v-1.9L66.6,31.3z M66.2,32.6V32v-0.5L63.6,30l-0.5-0.3v1.1L66.2,32.6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st19",
    d: "M66.6,31.3v1.9V31.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st19",
    d: "M67.1,31l-0.5,0.3L67.1,31z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st16",
    d: "M62.8,29.1l3.8,2.2L62.8,29.1z"
  }))), _polygon6 || (_polygon6 = /*#__PURE__*/React.createElement("polygon", {
    className: "st8",
    points: "42.5,14.8 45.3,13.2 46.9,14.1 48.1,14.8 53.1,17.7 50.3,19.3  "
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000044166398872414231240000007049349682489750411_",
    gradientUnits: "userSpaceOnUse",
    x1: 64.9302,
    y1: 10.386,
    x2: 86.9355,
    y2: 10.386
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#AEA388"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6,
    style: {
      stopColor: "#CDC3AB"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#E4DBC6"
    }
  })), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "url(#SVGID_00000044166398872414231240000007049349682489750411_)"
    },
    points: "64.9,3.7 86.9,16.4 85.8,17.1  64.9,5.1  "
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000115476208223521258650000001669680178854969748_",
    gradientUnits: "userSpaceOnUse",
    x1: 46.8837,
    y1: 9.2432,
    x2: 64.9302,
    y2: 9.2432
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#AEA388"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6,
    style: {
      stopColor: "#CDC3AB"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#E4DBC6"
    }
  })), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "url(#SVGID_00000115476208223521258650000001669680178854969748_)"
    },
    points: "46.9,14.1 64.9,3.7 64.9,5.1  64.2,5.4 64,5.3 60.8,7.2 60.8,7.4 48.1,14.8  "
  }), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    className: "st23",
    d: "M64.9,5.1l20.8,12L68.2,27.2l-15.2-8.8v-0.8l-5-2.9l12.7-7.4v1.4l6.8,3.9l3.2-1.9V9.3l-6.6-3.8L64.9,5.1z  M63,22.9l5.4,3.1l9.1-5.2v-2.6L72,15.1L63,20.3V22.9z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000120540185535867451710000010820458273186031021_",
    gradientUnits: "userSpaceOnUse",
    x1: 60.795,
    y1: 10.0026,
    x2: 67.6308,
    y2: 10.0026
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#AEA388"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6,
    style: {
      stopColor: "#CDC3AB"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#E4DBC6"
    }
  })), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "url(#SVGID_00000120540185535867451710000010820458273186031021_)"
    },
    points: "67.6,12.8 60.8,8.9 60.8,7.4  60.8,7.2 67.6,11.1  "
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000027599683981120773650000009620708650697939592_",
    gradientUnits: "userSpaceOnUse",
    x1: 67.6308,
    y1: 11.0389,
    x2: 70.8769,
    y2: 11.0389
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#AEA388"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6,
    style: {
      stopColor: "#CDC3AB"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#E4DBC6"
    }
  })), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "url(#SVGID_00000027599683981120773650000009620708650697939592_)"
    },
    points: "70.9,10.9 67.6,12.8 67.6,11.1  70.9,9.3  "
  }), _polygon7 || (_polygon7 = /*#__PURE__*/React.createElement("polygon", {
    className: "st8",
    points: "67.6,11.1 60.8,7.2 64,5.3 64.2,5.4 70.9,9.3  "
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000103985226366835191710000017331034742628282550_",
    gradientUnits: "userSpaceOnUse",
    x1: 44.33,
    y1: 12.1195,
    x2: 45.415,
    y2: 12.1195
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#AEA388"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6,
    style: {
      stopColor: "#CDC3AB"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#E4DBC6"
    }
  })), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "url(#SVGID_00000103985226366835191710000017331034742628282550_)"
    },
    points: "44.3,12.7 44.3,11.5 45.4,12.1  "
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000029731038386039509670000008541642355874475420_",
    gradientUnits: "userSpaceOnUse",
    x1: 51.5284,
    y1: 7.9635,
    x2: 52.6134,
    y2: 7.9635
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#AEA388"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6,
    style: {
      stopColor: "#CDC3AB"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#E4DBC6"
    }
  })), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "url(#SVGID_00000029731038386039509670000008541642355874475420_)"
    },
    points: "51.5,8.6 51.5,7.3 52.6,8  "
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000075850794663770437190000018346097838461477523_",
    gradientUnits: "userSpaceOnUse",
    x1: 58.2127,
    y1: 4.1043,
    x2: 59.2978,
    y2: 4.1043
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#AEA388"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6,
    style: {
      stopColor: "#CDC3AB"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#E4DBC6"
    }
  })), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "url(#SVGID_00000075850794663770437190000018346097838461477523_)"
    },
    points: "58.2,4.7 58.2,3.5 59.3,4.1  "
  }), _polygon8 || (_polygon8 = /*#__PURE__*/React.createElement("polygon", {
    className: "st8",
    points: "61.1,3.1 59.3,4.1 58.2,3.5 60,2.4  "
  })), _polygon9 || (_polygon9 = /*#__PURE__*/React.createElement("polygon", {
    className: "st8",
    points: "54.3,7 52.6,8 51.5,7.3 53.2,6.4  "
  })), _polygon10 || (_polygon10 = /*#__PURE__*/React.createElement("polygon", {
    className: "st8",
    points: "47,11.2 45.4,12.1 44.3,11.5 45.9,10.6  "
  })), _polygon11 || (_polygon11 = /*#__PURE__*/React.createElement("polygon", {
    className: "st29",
    points: "58.6,32.7 68.2,38.3 69.2,38.8 68.2,39.3 57.6,33.2  "
  })), _polygon12 || (_polygon12 = /*#__PURE__*/React.createElement("polygon", {
    className: "st29",
    points: "68.2,38.3 91.9,24.6 92.8,25.2 69.2,38.8  "
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "SVGID_00000014603022159989947020000006668421802938518198_",
    cx: 62.9263,
    cy: 39.0613,
    r: 5.5791,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#009CCD"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.86,
    style: {
      stopColor: "#0085B5"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#0081B1"
    }
  })), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "url(#SVGID_00000014603022159989947020000006668421802938518198_)"
    },
    points: "57.6,33.2 68.2,39.3 68.2,44.9  57.6,38.8  "
  }), _polygon13 || (_polygon13 = /*#__PURE__*/React.createElement("polygon", {
    className: "st31",
    points: "69.2,38.8 92.8,25.2 92.8,30.7 91.9,31.3 68.2,44.9 68.2,39.3  "
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000082326679299077000260000017039120078919345035_",
    gradientUnits: "userSpaceOnUse",
    x1: 62.9753,
    y1: 23.1749,
    x2: 68.3463,
    y2: 23.1749
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#AEA388"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6,
    style: {
      stopColor: "#CDC3AB"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#E4DBC6"
    }
  })), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "url(#SVGID_00000082326679299077000260000017039120078919345035_)"
    },
    points: "68.3,26 63,22.9 63,20.3  68.3,23.4  "
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000095331838197092342480000011169080770226901390_",
    gradientUnits: "userSpaceOnUse",
    x1: 68.3463,
    y1: 22.1126,
    x2: 77.3974,
    y2: 22.1126
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#AEA388"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6,
    style: {
      stopColor: "#CDC3AB"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#E4DBC6"
    }
  })), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "url(#SVGID_00000095331838197092342480000011169080770226901390_)"
    },
    points: "77.4,20.8 68.3,26 68.3,23.4  77.4,18.2  "
  }), _polygon14 || (_polygon14 = /*#__PURE__*/React.createElement("polygon", {
    className: "st8",
    points: "72,15.1 77.4,18.2 68.3,23.4 63,20.3  "
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000078029614705724834400000010717626294812464563_",
    gradientUnits: "userSpaceOnUse",
    x1: 46.8837,
    y1: 10.386,
    x2: 86.9355,
    y2: 10.386
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#AEA388"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6,
    style: {
      stopColor: "#CDC3AB"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#E4DBC6"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000078029614705724834400000010717626294812464563_)"
    },
    d: "M86.9,16.4l-22-12.7L86.9,16.4z M64.9,3.7 l-18,10.4L64.9,3.7z M85.8,17.1l-20.8-12L85.8,17.1z M64.9,5.1l-0.7,0.4L64.9,5.1z M60.8,7.4l-12.7,7.4L60.8,7.4z M64.9,3.7v1.4 V3.7z M60.8,8.9l6.8,3.9L60.8,8.9z M67.6,12.8l3.2-1.9L67.6,12.8z M60.8,7.2l6.8,3.9L60.8,7.2z M67.6,11.1l3.2-1.9L67.6,11.1z"
  }), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "st16",
    points: "48.8,54.6 43.9,51.8 44.6,51.3 48.8,53.7  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st19",
    points: "43.9,51.8 43.9,44.8 44.6,45.2 44.6,51.3  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st35",
    points: "44.6,51.3 44.6,45.2 48.8,47.6 48.8,53.7  "
  }))), /*#__PURE__*/React.createElement("g", null, _polygon15 || (_polygon15 = /*#__PURE__*/React.createElement("polygon", {
    className: "st16",
    points: "48.8,42.6 43.9,39.8 44.6,39.3 48.8,41.7  "
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000087371844346214235900000007764868045164617610_",
    gradientUnits: "userSpaceOnUse",
    x1: 43.8953,
    y1: 36.2744,
    x2: 44.6368,
    y2: 36.2744
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#AEA388"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6,
    style: {
      stopColor: "#CDC3AB"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#E4DBC6"
    }
  })), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "url(#SVGID_00000087371844346214235900000007764868045164617610_)"
    },
    points: "43.9,39.8 43.9,32.8 44.6,33.2  44.6,39.3  "
  }), _polygon16 || (_polygon16 = /*#__PURE__*/React.createElement("polygon", {
    className: "st35",
    points: "44.6,39.3 44.6,33.2 48.8,35.6 48.8,41.7  "
  }))), /*#__PURE__*/React.createElement("g", null, _polygon17 || (_polygon17 = /*#__PURE__*/React.createElement("polygon", {
    className: "st8",
    points: "48.8,30.6 43.9,27.8 44.6,27.4 48.8,29.8  "
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000126301491688983287660000004236002228023925943_",
    gradientUnits: "userSpaceOnUse",
    x1: 43.8953,
    y1: 24.2952,
    x2: 44.6368,
    y2: 24.2952
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#AEA388"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6,
    style: {
      stopColor: "#CDC3AB"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#E4DBC6"
    }
  })), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "url(#SVGID_00000126301491688983287660000004236002228023925943_)"
    },
    points: "43.9,27.8 43.9,20.8 44.6,21.2  44.6,27.4  "
  }), _polygon18 || (_polygon18 = /*#__PURE__*/React.createElement("polygon", {
    className: "st35",
    points: "44.6,27.4 44.6,21.2 48.8,23.6 48.8,29.8  "
  }))), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "st35",
    points: "66.1,52.4 54.2,45.4 54.2,56.2 66.2,63.1  "
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", {
    className: "st2"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "st19",
    points: "56.1,57.4 56.3,57.3 56.3,57.4 56.1,57.5  "
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "st16",
    points: "54.1,56.3 54.3,56.2 56.3,57.3 56.1,57.4  "
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "st16",
    points: "56.1,57.5 56.3,57.4 56.4,57.5 56.3,57.6  "
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "st19",
    points: "56.3,57.5 56.4,57.4 56.4,57.5 56.3,57.6  "
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "st16",
    points: "56.3,57.5 56.4,57.4 58.2,58.5 58.1,58.5  "
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "st19",
    points: "58.1,58.5 58.2,58.5 58.2,58.5 58.1,58.6  "
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "st16",
    points: "58.1,58.6 58.2,58.5 58.4,58.6 58.2,58.7  "
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "st19",
    points: "58.2,58.6 58.4,58.5 58.4,58.6 58.2,58.7  "
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "st19",
    points: "60.1,59.7 60.2,59.6 60.2,59.7 60.1,59.8  "
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "st16",
    points: "58.2,58.6 58.4,58.5 60.2,59.6 60.1,59.7  "
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "st16",
    points: "60.1,59.8 60.2,59.7 60.4,59.8 60.2,59.9  "
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "st19",
    points: "60.2,59.8 60.4,59.7 60.4,59.8 60.2,59.9  "
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "st19",
    points: "54.1,48.7 54.3,48.6 54.3,56.2 54.1,56.3  "
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "st16",
    points: "54,48.7 54.2,48.6 54.3,48.6 54.1,48.7  "
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "st19",
    points: "54,48.5 54.2,48.4 54.2,48.6 54,48.7  "
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "st16",
    points: "54,48.5 54.2,48.4 54.3,48.4 54.1,48.5  "
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "st19",
    points: "62.1,60.8 62.2,60.8 62.2,60.8 62.1,60.9  "
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "st16",
    points: "60.2,59.8 60.4,59.7 62.2,60.8 62.1,60.8  "
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "st16",
    points: "62.1,60.9 62.2,60.8 62.4,60.9 62.2,61  "
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "st19",
    points: "62.2,60.9 62.4,60.8 62.4,60.9 62.2,61  "
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "st19",
    points: "54.1,45.4 54.3,45.4 54.3,48.4 54.1,48.5  "
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "st19",
    points: "56.3,49.9 56.4,49.9 56.4,57.4 56.3,57.5  "
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "st16",
    points: "54.1,48.5 54.3,48.4 56.3,49.6 56.1,49.7  "
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "st19",
    points: "56.1,49.7 56.3,49.6 56.3,49.8 56.1,49.9  "
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "st19",
    points: "56.3,49.8 56.4,49.7 56.4,49.9 56.3,49.9  "
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "st16",
    points: "62.2,60.9 62.4,60.8 64.2,61.9 64,62  "
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "st19",
    points: "64,62 64.2,61.9 64.2,62 64,62.1  "
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "st16",
    points: "64,62.1 64.2,62 64.3,62.1 64.2,62.2  "
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "st19",
    points: "64.2,62.1 64.3,62 64.3,62.1 64.2,62.2  "
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "st19",
    points: "56.1,46.5 56.3,46.4 56.3,46.5 56.1,46.6  "
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "st19",
    points: "56.3,46.7 56.4,46.6 56.4,49.7 56.3,49.8  "
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "st19",
    points: "56.3,46.6 56.4,46.5 56.4,46.6 56.3,46.7  "
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "st16",
    points: "56.1,46.5 56.3,46.4 56.4,46.5 56.3,46.6  "
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "st19",
    points: "58.2,51.1 58.4,51 58.4,58.5 58.2,58.6  "
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "st19",
    points: "58.1,50.8 58.2,50.7 58.2,50.9 58.1,51  "
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "st16",
    points: "56.3,49.8 56.4,49.7 58.2,50.7 58.1,50.8  "
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "st19",
    points: "58.2,50.9 58.4,50.8 58.4,51 58.2,51.1  "
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "st16",
    points: "64.2,62.1 64.3,62 66.2,63 66,63.1  "
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "st19",
    points: "58.1,47.7 58.2,47.6 58.2,47.7 58.1,47.7  "
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "st19",
    points: "58.2,47.8 58.4,47.7 58.4,50.8 58.2,50.9  "
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "st19",
    points: "58.2,47.7 58.4,47.7 58.4,47.7 58.2,47.8  "
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "st16",
    points: "58.1,47.7 58.2,47.6 58.4,47.7 58.2,47.7  "
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "st19",
    points: "60.2,52.2 60.4,52.1 60.4,59.7 60.2,59.8  "
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "st16",
    points: "58.2,50.9 58.4,50.8 60.2,51.9 60.1,52  "
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "st19",
    points: "60.1,52 60.2,51.9 60.2,52.1 60.1,52.1  "
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "st19",
    points: "60.2,52.1 60.4,52 60.4,52.1 60.2,52.2  "
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "st19",
    points: "60.1,48.8 60.2,48.7 60.2,48.8 60.1,48.9  "
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "st19",
    points: "60.2,49 60.4,48.9 60.4,52 60.2,52.1  "
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "st19",
    points: "60.2,48.9 60.4,48.8 60.4,48.9 60.2,49  "
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "st16",
    points: "60.1,48.8 60.2,48.7 60.4,48.8 60.2,48.9  "
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "st19",
    points: "62.2,53.4 62.4,53.3 62.4,60.8 62.2,60.9  "
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "st16",
    points: "60.2,52.1 60.4,52 62.2,53 62.1,53.1  "
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "st19",
    points: "62.1,53.1 62.2,53 62.2,53.2 62.1,53.3  "
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "st19",
    points: "62.2,53.2 62.4,53.1 62.4,53.3 62.2,53.4  "
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "st19",
    points: "62.1,49.9 62.2,49.9 62.2,49.9 62.1,50  "
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "st19",
    points: "62.2,50.1 62.4,50 62.4,53.1 62.2,53.2  "
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "st19",
    points: "62.2,50 62.4,49.9 62.4,50 62.2,50.1  "
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "st16",
    points: "62.1,49.9 62.2,49.9 62.4,49.9 62.2,50  "
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "st19",
    points: "64.2,54.5 64.3,54.4 64.3,62 64.2,62.1  "
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "st19",
    points: "64,54.3 64.2,54.2 64.2,54.4 64,54.4  "
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "st16",
    points: "62.2,53.2 62.4,53.1 64.2,54.2 64,54.3  "
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "st19",
    points: "64.2,54.4 64.3,54.3 64.3,54.4 64.2,54.5  "
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "st19",
    points: "64,51.1 64.2,51 64.2,51.1 64,51.2  "
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "st19",
    points: "64.2,51.3 64.3,51.2 64.3,54.3 64.2,54.4  "
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "st16",
    points: "66,55.6 66.2,55.5 66.3,55.5 66.1,55.6  "
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "st16",
    points: "64,51.1 64.2,51 64.3,51.1 64.2,51.2  "
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "st19",
    points: "64.2,51.2 64.3,51.1 64.3,51.2 64.2,51.3  "
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "st16",
    points: "64.2,54.4 64.3,54.3 66.2,55.3 66,55.4  "
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "st16",
    points: "66,55.4 66.2,55.3 66.3,55.4 66.1,55.5  "
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "st19",
    points: "66.1,55.5 66.3,55.4 66.3,55.5 66.1,55.6  "
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "st38",
    points: "58.1,50.8 56.3,49.8 56.3,49.9 58.1,51  "
  }), /*#__PURE__*/React.createElement("path", {
    className: "st38",
    d: "M54,45.2v11.2l12.2,7V52.2L54,45.2z M66,55.4l-1.8-1.1l0,0l0-3.1l1.8,1.1L66,55.4z M60.1,48.8L60.1,48.8 L60.1,48.8l0,3.2l0,0.2l0-0.2l-1.8-1.1v0v0l0-3.1l0-0.1l0,0l0,0.1L60.1,48.8L60.1,48.8z M54.1,45.4l2,1.1l0,3.1l0,0l-2-1.1 L54.1,45.4z M54.1,48.7l2,1.1l0,7.5l0,0.1l0,0l0-0.1l-2-1.1L54.1,48.7z M56.3,57.5l0-7.5l0-0.2l0-3.1l1.8,1.1l0-0.1l0,0l0,0.1 l0,3.1l0,0.2l0,7.5l0,0.1l0,0l0-0.1L56.3,57.5z M58.2,58.6l0-7.5l1.8,1.1l0,7.5l0,0.1l0,0l0-0.1L58.2,58.6z M60.2,59.8l0-7.5 l1.8,1.1l0-0.2l-1.8-1.1v0l0-3.1l1.8,1.1l0-0.1l0,0l0,0.1l0,3.1l0,0.2l0,7.5l0,0.1l0,0l0-0.1L60.2,59.8z M62.2,60.9l0-7.5 l1.8,1.1l0-0.2l-1.8-1.1l0,0l0-3.1l1.8,1.1l0-0.1l0,0l0,0.1l0,3.1l0,0.2l0,7.5l0,0.1l0,0l0-0.1L62.2,60.9z M66,63.1l-1.8-1.1 l0-7.5l1.8,1.1L66,63.1z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "st16",
    points: "54,45.2 54.1,45.1 66.3,52.2 66.2,52.2  "
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "st19",
    points: "66.2,52.2 66.3,52.2 66.3,63.3 66.2,63.4  "
  }))))))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, _polygon19 || (_polygon19 = /*#__PURE__*/React.createElement("polygon", {
    className: "st29",
    points: "53.9,80.3 53.9,55.2 64.8,48.9 64.8,49.1 64.8,72.2 64.8,73.9  "
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "SVGID_00000009577925581899575720000017964669131397439114_",
    cx: 53.1328,
    cy: 67.307,
    r: 9.1682,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#009CCD"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.86,
    style: {
      stopColor: "#0085B5"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#0081B1"
    }
  })), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "url(#SVGID_00000009577925581899575720000017964669131397439114_)"
    },
    points: "53.9,55.2 53.9,80.3 52.4,79.4  52.4,56.3 52.4,54.4  "
  }), /*#__PURE__*/React.createElement("radialGradient", {
    id: "SVGID_00000057844314078652193390000015311510139711735739_",
    cx: 58.6112,
    cy: 51.6181,
    r: 5.0663,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#009CCD"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.86,
    style: {
      stopColor: "#0085B5"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#0081B1"
    }
  })), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "url(#SVGID_00000057844314078652193390000015311510139711735739_)"
    },
    points: "64.8,48.9 53.9,55.2 52.4,54.4  63.4,48  "
  }), _polygon20 || (_polygon20 = /*#__PURE__*/React.createElement("polygon", {
    className: "st29",
    points: "52.4,56.3 52.4,79.4 41.3,85.8 41.3,62.7  "
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "SVGID_00000104695583301262404680000005055470977747552905_",
    cx: 44.266,
    cy: 50.0381,
    r: 17.8455,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#009CCD"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.86,
    style: {
      stopColor: "#0085B5"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#0081B1"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000104695583301262404680000005055470977747552905_)"
    },
    d: "M52.4,54.4v1.9l-11.1,6.4L22.4,51.7 l24.8-14.3l18.9,10.9l-1.3,0.8v-0.2L63.4,48L52.4,54.4z M62.4,48.3l-15.2-8.8l-8.4,4.8l-1.1-0.6L30.5,48v1.3l-4.3,2.5l0.9,0.5 l14.3,8.3l20.2-11.6L62.4,48.3z"
  }), /*#__PURE__*/React.createElement("radialGradient", {
    id: "SVGID_00000060709664522296262160000014099787360593951156_",
    cx: 31.8693,
    cy: 68.7715,
    r: 13.7797,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#009CCD"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.86,
    style: {
      stopColor: "#0085B5"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#0081B1"
    }
  })), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "url(#SVGID_00000060709664522296262160000014099787360593951156_)"
    },
    points: "41.3,62.7 41.3,85.8 22.4,74.9  22.4,51.7  "
  }), _polygon21 || (_polygon21 = /*#__PURE__*/React.createElement("polygon", {
    className: "st29",
    points: "66.1,71.5 64.8,72.2 64.8,49.1 66.1,48.3  "
  })), _polygon22 || (_polygon22 = /*#__PURE__*/React.createElement("polygon", {
    className: "st29",
    points: "47.2,39.6 62.4,48.3 61.5,48.9 47.2,40.6  "
  })), _polygon23 || (_polygon23 = /*#__PURE__*/React.createElement("polygon", {
    className: "st29",
    points: "38.8,44.4 47.2,39.6 47.2,40.6 39.7,44.9  "
  })), _polygon24 || (_polygon24 = /*#__PURE__*/React.createElement("polygon", {
    className: "st29",
    points: "26.1,51.7 30.5,49.2 30.5,50.3 27,52.2  "
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "SVGID_00000011709904631684470770000013291788686017052343_",
    cx: 44.266,
    cy: 50.5526,
    r: 14.0712,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#009CCD"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.86,
    style: {
      stopColor: "#0085B5"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#0081B1"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000011709904631684470770000013291788686017052343_)"
    },
    d: "M47.2,40.6l14.3,8.3L41.3,60.5L27,52.2 l3.4-2v1.1l4.8,2.8l7.3-4.2v-3.4l-2.8-1.6L47.2,40.6z M54.3,52.2l4.1-2.4v-1.1l-11.9-6.9l-4.1,2.4v1.1L54.3,52.2z"
  }), _polygon25 || (_polygon25 = /*#__PURE__*/React.createElement("polygon", {
    className: "st29",
    points: "35.2,54.2 30.5,51.4 30.5,50.3 30.5,49.2 30.5,48 35.2,50.7  "
  })), _polygon26 || (_polygon26 = /*#__PURE__*/React.createElement("polygon", {
    className: "st29",
    points: "42.5,49.9 35.2,54.2 35.2,50.7 42.5,46.5  "
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "SVGID_00000181070191328251894180000004739685929255035782_",
    cx: 36.5036,
    cy: 47.2541,
    r: 4.9308,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#009CCD"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.86,
    style: {
      stopColor: "#0085B5"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#0081B1"
    }
  })), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "url(#SVGID_00000181070191328251894180000004739685929255035782_)"
    },
    points: "35.2,50.7 30.5,48 37.8,43.8  38.8,44.4 39.7,44.9 42.5,46.5  "
  }), _polygon27 || (_polygon27 = /*#__PURE__*/React.createElement("polygon", {
    className: "st29",
    points: "58.4,49.8 54.3,52.2 54.3,51.1 58.4,48.7  "
  })), _polygon28 || (_polygon28 = /*#__PURE__*/React.createElement("polygon", {
    className: "st29",
    points: "54.3,52.2 42.3,45.3 42.3,44.2 54.3,51.1  "
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "SVGID_00000109717273098303509020000015881108603492491908_",
    cx: 50.3816,
    cy: 46.4621,
    r: 6.5595,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#009CCD"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.86,
    style: {
      stopColor: "#0085B5"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#0081B1"
    }
  })), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "url(#SVGID_00000109717273098303509020000015881108603492491908_)"
    },
    points: "42.3,44.2 46.5,41.8 58.4,48.7  54.3,51.1  "
  })), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", {
    id: "window_4_"
  }, /*#__PURE__*/React.createElement("polygon", {
    className: "st35",
    points: "38.5,74.2 32.8,71 32.8,80 38.5,83.3  "
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", {
    className: "st2"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "st16",
    points: "32.9,79.9 33,79.9 34.6,80.8 34.5,80.9  "
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "st46",
    points: "32.9,77.9 33,77.8 33,79.9 32.9,79.9  "
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "st16",
    points: "34.7,81 34.8,80.9 36.5,81.9 36.4,82  "
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "st46",
    points: "34.7,79 34.8,78.9 34.8,80.9 34.7,81  "
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "st16",
    points: "32.9,77.7 33,77.6 34.6,78.6 34.5,78.6  "
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "st46",
    points: "32.9,75.6 33,75.6 33,77.6 32.9,77.7  "
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "st16",
    points: "36.6,82.1 36.7,82 38.3,83 38.2,83  "
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "st46",
    points: "36.6,80 36.7,80 36.7,82 36.6,82.1  "
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "st16",
    points: "34.7,78.7 34.8,78.7 36.5,79.6 36.4,79.7  "
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "st46",
    points: "34.7,76.7 34.8,76.6 34.8,78.7 34.7,78.7  "
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "st16",
    points: "32.9,75.4 33,75.3 34.6,76.3 34.5,76.3  "
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "st46",
    points: "32.9,73.4 33,73.3 33,75.3 32.9,75.4  "
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "st16",
    points: "36.6,79.8 36.7,79.7 38.3,80.7 38.2,80.8  "
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "st46",
    points: "36.6,77.8 36.7,77.7 36.7,79.7 36.6,79.8  "
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "st16",
    points: "34.7,76.5 34.8,76.4 36.5,77.4 36.4,77.4  "
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "st46",
    points: "34.7,74.4 34.8,74.4 34.8,76.4 34.7,76.5  "
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "st16",
    points: "32.9,73.1 33,73.1 34.6,74 34.5,74.1  "
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "st46",
    points: "32.9,71.1 33,71 33,73.1 32.9,73.1  "
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "st16",
    points: "36.6,77.5 36.7,77.5 38.4,78.4 38.3,78.5  "
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "st46",
    points: "36.6,75.5 36.7,75.4 36.7,77.5 36.6,77.5  "
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "st16",
    points: "34.7,74.2 34.8,74.1 36.5,75.1 36.4,75.2  "
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "st46",
    points: "34.7,72.2 34.8,72.1 34.8,74.1 34.7,74.2  "
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "st16",
    points: "36.6,75.3 36.7,75.2 38.4,76.2 38.3,76.2  "
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "st46",
    points: "36.6,73.2 36.7,73.2 36.7,75.2 36.6,75.3  "
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "st16",
    points: "38.5,74.1 38.6,74 38.5,83.3 38.4,83.4  "
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "st16",
    points: "32.7,70.7 32.8,70.7 38.6,74 38.5,74.1  "
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st47",
    d: "M32.7,70.7l5.8,3.3l0,9.3L32.7,80L32.7,70.7z M34.5,76.3l0-2l-1.7-1l0,2L34.5,76.3L34.5,76.3z M36.4,77.4 l0-2l-1.7-1l0,2L36.4,77.4L36.4,77.4z M38.3,78.5l0-2l-1.7-1l0,2L38.3,78.5L38.3,78.5z M34.5,80.9l0-2l-1.7-1l0,2L34.5,80.9 L34.5,80.9z M36.4,82l0-2l-1.7-1l0,2L36.4,82L36.4,82z M38.2,83l0-2l-1.7-1l0,2L38.2,83L38.2,83z M36.4,75.2l0-2l-1.7-1l0,2 L36.4,75.2L36.4,75.2z M36.4,79.7l0-2l-1.7-1l0,2L36.4,79.7L36.4,79.7z M34.5,78.6l0-2l-1.7-1l0,2L34.5,78.6L34.5,78.6z  M34.5,74.1l0-2l-1.7-1l0,2L34.5,74.1L34.5,74.1z M38.3,76.2l0-2l-1.7-1l0,2L38.3,76.2L38.3,76.2z M38.2,80.8l0-2l-1.7-1l0,2 L38.2,80.8L38.2,80.8z"
  })))))), _g6 || (_g6 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "st35",
    points: "23.4,56.6 27.3,58.9 27.3,58.2 27.3,56.6 24,54.7 23.9,54.7 23.4,55  "
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "st48",
    points: "23.4,56.6 24,56.2 24,54.7 23.4,54.3  "
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "st47",
    points: "23.4,56.6 27.3,58.9 27.3,58.2 24,56.2  "
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "st35",
    points: "29.5,60.1 33.4,62.4 33.4,61.7 33.4,60.1 30.1,58.2 30,58.2 29.5,58.5  "
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "st48",
    points: "29.5,60.1 30.1,59.7 30.1,58.2 29.5,57.8  "
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "st47",
    points: "29.5,60.1 33.4,62.4 33.4,61.7 30.1,59.7  "
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "st35",
    points: "35.6,63.6 39.6,65.9 39.6,65.2 39.6,63.6 36.2,61.7 36.2,61.7 35.6,62  "
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "st48",
    points: "35.6,63.6 36.2,63.2 36.2,61.7 35.6,61.3  "
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "st47",
    points: "35.6,63.6 39.6,65.9 39.6,65.2 36.2,63.2  "
  })))))), _g7 || (_g7 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "st35",
    points: "23.4,63.1 27.3,65.4 27.3,64.7 27.3,63.1 24,61.2 23.9,61.2 23.4,61.5  "
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "st48",
    points: "23.4,63.1 24,62.7 24,61.2 23.4,60.9  "
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "st47",
    points: "23.4,63.1 27.3,65.4 27.3,64.7 24,62.7  "
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "st35",
    points: "29.5,66.6 33.4,68.9 33.4,68.2 33.4,66.6 30.1,64.7 30,64.7 29.5,65  "
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "st48",
    points: "29.5,66.6 30.1,66.2 30.1,64.7 29.5,64.4  "
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "st47",
    points: "29.5,66.6 33.4,68.9 33.4,68.2 30.1,66.2  "
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "st35",
    points: "35.6,70.1 39.6,72.4 39.6,71.7 39.6,70.1 36.2,68.2 36.2,68.2 35.6,68.5  "
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "st48",
    points: "35.6,70.1 36.2,69.7 36.2,68.2 35.6,67.9  "
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "st47",
    points: "35.6,70.1 39.6,72.4 39.6,71.7 36.2,69.7  "
  }))))))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", {
    className: "st2"
  }, /*#__PURE__*/React.createElement("g", {
    className: "st2"
  }, _defs2 || (_defs2 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "SVGID_00000100353658711330629700000003434299490721483662_",
    className: "st2",
    d: "M84.8,61.8l0,8.6c0,0.3-0.2,0.6-0.6,0.9 c-0.8,0.5-2.2,0.5-3,0c-0.4-0.2-0.6-0.6-0.6-0.9l0-8.6c0,0.3,0.2,0.6,0.6,0.9c0.8,0.5,2.2,0.5,3,0 C84.6,62.4,84.8,62.1,84.8,61.8z"
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000150083464292222253340000015738099352896779684_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_00000100353658711330629700000003434299490721483662_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#SVGID_00000150083464292222253340000015738099352896779684_)",
      enableBackground: "new"
    }
  }, _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M84.8,61.8l0,8.6c0,0.3-0.2,0.6-0.6,0.9c-0.1,0-0.2,0.1-0.2,0.1l0-8.6c0.1,0,0.2-0.1,0.2-0.1 C84.6,62.4,84.8,62.1,84.8,61.8L84.8,61.8z"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M83.9,62.8l0,8.6c-0.3,0.1-0.7,0.2-1,0.2l0-8.6C83.3,63,83.6,62.9,83.9,62.8L83.9,62.8z"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M81.6,62.8l0,8.6c-0.2-0.1-0.3-0.1-0.5-0.2c-0.1-0.1-0.2-0.2-0.3-0.2l0-8.6c0.1,0.1,0.2,0.2,0.3,0.2 C81.3,62.7,81.5,62.8,81.6,62.8L81.6,62.8z"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M80.8,62.4l0,8.6c-0.2-0.2-0.3-0.4-0.3-0.6l0-8.6C80.5,62,80.6,62.2,80.8,62.4L80.8,62.4z"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#SVGID_00000150083464292222253340000015738099352896779684_)"
    }
  }, _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    className: "st7",
    d: "M82.9,63.6l0-0.6c-0.4,0-0.9,0-1.3-0.1l0,0.6C82,63.6,82.5,63.6,82.9,63.6z"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    className: "st7",
    d: "M81.6,68.6l0,1c0.4,0.1,0.8,0.2,1.3,0.1l0-1C82.4,68.8,82,68.8,81.6,68.6z"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    className: "st7",
    d: "M81.6,70.7l0,0.7c0.4,0.1,0.8,0.2,1.3,0.1l0-0.7C82.4,70.9,82,70.8,81.6,70.7z"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    className: "st7",
    d: "M81.6,64.5l0,1c0.4,0.1,0.8,0.2,1.3,0.1l0-1C82.5,64.7,82,64.6,81.6,64.5z"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    className: "st7",
    d: "M81.6,66.6l0,1c0.4,0.1,0.8,0.2,1.3,0.1l0-1C82.5,66.7,82,66.7,81.6,66.6z"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    className: "st51",
    d: "M81.2,69.5c-0.4-0.2-0.6-0.6-0.6-0.9l0,1c0,0.3,0.2,0.6,0.6,0.9c0.1,0.1,0.3,0.1,0.5,0.2l0-1 C81.5,69.6,81.3,69.6,81.2,69.5z"
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    className: "st51",
    d: "M84.1,70.5c0.4-0.2,0.6-0.5,0.6-0.9l0-1c0,0.3-0.2,0.6-0.6,0.9c-0.4,0.2-0.8,0.3-1.3,0.4l0,1 C83.3,70.8,83.8,70.7,84.1,70.5z"
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    className: "st52",
    d: "M81.6,69.7l0,1c0.4,0.1,0.8,0.2,1.3,0.1l0-1C82.4,69.8,82,69.8,81.6,69.7z"
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    className: "st51",
    d: "M84.1,68.4c0.4-0.2,0.6-0.5,0.6-0.9l0-1c0,0.3-0.2,0.6-0.6,0.9c-0.4,0.2-0.8,0.3-1.3,0.4l0,1 C83.3,68.8,83.8,68.6,84.1,68.4z"
  })), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    className: "st51",
    d: "M81.2,67.4c-0.4-0.2-0.6-0.6-0.6-0.9l0,1c0,0.3,0.2,0.6,0.6,0.9c0.1,0.1,0.3,0.1,0.5,0.2l0-1 C81.5,67.5,81.3,67.5,81.2,67.4z"
  })), _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    className: "st52",
    d: "M81.6,67.6l0,1c0.4,0.1,0.8,0.2,1.3,0.1l0-1C82.5,67.8,82,67.7,81.6,67.6z"
  })), _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    className: "st51",
    d: "M84.1,66.4c0.4-0.2,0.6-0.5,0.6-0.9l0-1c0,0.3-0.2,0.6-0.6,0.9c-0.4,0.2-0.8,0.3-1.3,0.4l0,1 C83.3,66.7,83.8,66.6,84.1,66.4z"
  })), _path33 || (_path33 = /*#__PURE__*/React.createElement("path", {
    className: "st51",
    d: "M81.2,65.3c-0.4-0.2-0.6-0.6-0.6-0.9l0,0l0,1c0,0.3,0.2,0.6,0.6,0.9c0.1,0.1,0.3,0.1,0.5,0.2l0-1 C81.5,65.5,81.3,65.4,81.2,65.3z"
  })), _path34 || (_path34 = /*#__PURE__*/React.createElement("path", {
    className: "st52",
    d: "M81.6,65.5l0,1c0.4,0.1,0.8,0.2,1.3,0.1l0-1C82.5,65.7,82,65.7,81.6,65.5z"
  })), _path35 || (_path35 = /*#__PURE__*/React.createElement("path", {
    className: "st51",
    d: "M81.2,63.3c-0.4-0.2-0.6-0.6-0.6-0.9l0,1c0,0.3,0.2,0.6,0.6,0.9c0.1,0.1,0.3,0.1,0.5,0.2l0-1 C81.5,63.4,81.3,63.3,81.2,63.3z"
  })), _path36 || (_path36 = /*#__PURE__*/React.createElement("path", {
    className: "st51",
    d: "M84.2,64.3c0.4-0.2,0.6-0.5,0.6-0.9l0-1c0,0.3-0.2,0.6-0.6,0.9c-0.4,0.2-0.8,0.3-1.3,0.4l0,1 C83.4,64.6,83.8,64.5,84.2,64.3z"
  })), _path37 || (_path37 = /*#__PURE__*/React.createElement("path", {
    className: "st52",
    d: "M82.9,64.7l0-1c-0.4,0-0.9,0-1.3-0.1l0,1C82,64.6,82.5,64.7,82.9,64.7z"
  })))), _g8 || (_g8 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st53",
    d: "M84.1,60.9c0.8,0.5,0.8,1.3,0,1.7c-0.8,0.5-2.2,0.5-3,0c-0.8-0.5-0.8-1.3,0-1.7 C82,60.4,83.3,60.4,84.1,60.9z"
  }))), _g9 || (_g9 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st54",
    d: "M83.7,61.2c0.6,0.3,0.6,0.9,0,1.2c-0.6,0.3-1.5,0.3-2.1,0c-0.6-0.3-0.6-0.9,0-1.2 C82.2,60.8,83.1,60.8,83.7,61.2z"
  })))))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("radialGradient", {
    id: "SVGID_00000055705339898524897580000016149170611984174767_",
    cx: 94.5056,
    cy: 75.9243,
    r: 7.1616,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#009CCD"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.86,
    style: {
      stopColor: "#0085B5"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#0081B1"
    }
  })), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "url(#SVGID_00000055705339898524897580000016149170611984174767_)"
    },
    points: "90,85 90,72.1 99,66.9 99,67  99,78.4 99,79.8  "
  }), /*#__PURE__*/React.createElement("radialGradient", {
    id: "SVGID_00000153686674372070585000000000966909000516465542_",
    cx: 89.3809,
    cy: 78.1901,
    r: 4.8238,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#009CCD"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.86,
    style: {
      stopColor: "#0085B5"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#0081B1"
    }
  })), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "url(#SVGID_00000153686674372070585000000000966909000516465542_)"
    },
    points: "90,72.1 90,85 88.8,84.3  88.8,73 88.8,71.4  "
  }), /*#__PURE__*/React.createElement("radialGradient", {
    id: "SVGID_00000072239271484490254290000016525334731838323864_",
    cx: 93.9056,
    cy: 69.1289,
    r: 4.1843,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#009CCD"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.86,
    style: {
      stopColor: "#0085B5"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#0081B1"
    }
  })), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "url(#SVGID_00000072239271484490254290000016525334731838323864_)"
    },
    points: "99,66.9 90,72.1 88.8,71.4  97.8,66.2  "
  }), _polygon29 || (_polygon29 = /*#__PURE__*/React.createElement("polygon", {
    className: "st29",
    points: "88.8,73 88.8,84.3 79.6,89.6 79.6,78.2  "
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "SVGID_00000050644729744764878820000018049657002059820945_",
    cx: 82.0577,
    cy: 67.8239,
    r: 14.7388,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#009CCD"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.86,
    style: {
      stopColor: "#0085B5"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#0081B1"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000050644729744764878820000018049657002059820945_)"
    },
    d: "M88.8,71.4V73l-9.1,5.3l-15.6-9 l20.5-11.8l15.6,9L99,67v-0.2l-1.2-0.7L88.8,71.4z M97,66.4l-12.5-7.2l-6.9,4l-0.9-0.5l-6,3.5v1l-3.6,2.1l0.7,0.4l11.8,6.8 l16.7-9.6L97,66.4z"
  }), /*#__PURE__*/React.createElement("radialGradient", {
    id: "SVGID_00000074413250147114294110000010152443829369488031_",
    cx: 71.8191,
    cy: 79.3997,
    r: 9.0711,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#009CCD"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.86,
    style: {
      stopColor: "#0085B5"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#0081B1"
    }
  })), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "url(#SVGID_00000074413250147114294110000010152443829369488031_)"
    },
    points: "79.6,78.2 79.6,89.6 64,80.6  64,69.2  "
  }), _polygon30 || (_polygon30 = /*#__PURE__*/React.createElement("polygon", {
    className: "st29",
    points: "100.1,77.8 99,78.4 99,67 100.1,66.4  "
  })), _polygon31 || (_polygon31 = /*#__PURE__*/React.createElement("polygon", {
    className: "st29",
    points: "84.5,59.2 97,66.4 96.3,66.8 84.5,60  "
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "SVGID_00000052816839231985356390000000565662030096163509_",
    cx: 81.0336,
    cy: 61.3857,
    r: 2.895,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#009CCD"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.86,
    style: {
      stopColor: "#0085B5"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#0081B1"
    }
  })), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "url(#SVGID_00000052816839231985356390000000565662030096163509_)"
    },
    points: "77.6,63.2 84.5,59.2 84.5,60  78.3,63.6  "
  }), _polygon32 || (_polygon32 = /*#__PURE__*/React.createElement("polygon", {
    className: "st29",
    points: "67.1,69.2 70.7,67.2 70.7,68 67.8,69.6  "
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "SVGID_00000165914611508914820800000014705289431974769287_",
    cx: 82.0577,
    cy: 68.2488,
    r: 11.6215,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#009CCD"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.86,
    style: {
      stopColor: "#0085B5"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#0081B1"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000165914611508914820800000014705289431974769287_)"
    },
    d: "M84.5,60l11.8,6.8l-16.7,9.6l-11.8-6.8 l2.8-1.6v0.9l4,2.3l6-3.5v-2.8l-2.3-1.3L84.5,60z M90.3,69.6l3.4-2v-0.9L83.9,61l-3.4,2v0.9L90.3,69.6z"
  }), _polygon33 || (_polygon33 = /*#__PURE__*/React.createElement("polygon", {
    className: "st29",
    points: "74.6,71.2 70.7,68.9 70.7,68 70.7,67.2 70.7,66.1 74.6,68.4  "
  })), _polygon34 || (_polygon34 = /*#__PURE__*/React.createElement("polygon", {
    className: "st29",
    points: "80.6,67.8 74.6,71.2 74.6,68.4 80.6,64.9  "
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "SVGID_00000163758917583860831050000014151923638109499009_",
    cx: 75.6467,
    cy: 65.5246,
    r: 4.0724,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#009CCD"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.86,
    style: {
      stopColor: "#0085B5"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#0081B1"
    }
  })), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "url(#SVGID_00000163758917583860831050000014151923638109499009_)"
    },
    points: "74.6,68.4 70.7,66.1 76.7,62.6  77.6,63.2 78.3,63.6 80.6,64.9  "
  }), /*#__PURE__*/React.createElement("radialGradient", {
    id: "SVGID_00000183237288105755007170000018137134556816449961_",
    cx: 92.0425,
    cy: 68.1636,
    r: 1.57,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#009CCD"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.86,
    style: {
      stopColor: "#0085B5"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#0081B1"
    }
  })), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "url(#SVGID_00000183237288105755007170000018137134556816449961_)"
    },
    points: "93.7,67.6 90.3,69.6 90.3,68.7  93.7,66.7  "
  }), _polygon35 || (_polygon35 = /*#__PURE__*/React.createElement("polygon", {
    className: "st29",
    points: "90.3,69.6 80.5,63.9 80.5,63 90.3,68.7  "
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "SVGID_00000085958197845107908540000015671166268083065529_",
    cx: 87.1086,
    cy: 64.8705,
    r: 5.4175,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#009CCD"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.86,
    style: {
      stopColor: "#0085B5"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#0081B1"
    }
  })), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "url(#SVGID_00000085958197845107908540000015671166268083065529_)"
    },
    points: "80.5,63 83.9,61 93.7,66.7  90.3,68.7  "
  })), _g10 || (_g10 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "st35",
    points: "98.4,71.3 96.6,72.3 96.6,71.6 96.6,69.4 97.8,68.8 97.9,68.8 98.4,69.1  "
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "st46",
    points: "98.4,71.3 97.8,70.9 97.8,68.8 98.4,68.4  "
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "st47",
    points: "98.4,71.3 96.6,72.3 96.6,71.6 97.8,70.9  "
  })))), _g11 || (_g11 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "st35",
    points: "98.4,76.8 96.6,77.8 96.6,77.1 96.6,74.9 97.8,74.3 97.9,74.3 98.4,74.6  "
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "st46",
    points: "98.4,76.8 97.8,76.4 97.8,74.3 98.4,73.9  "
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "st47",
    points: "98.4,76.8 96.6,77.8 96.6,77.1 97.8,76.4  "
  })))), _g12 || (_g12 = /*#__PURE__*/React.createElement("g", {
    id: "window_3_"
  }, /*#__PURE__*/React.createElement("polygon", {
    className: "st35",
    points: "80.5,78.9 86.3,75.5 86.4,84.8 80.4,88.3  "
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", {
    className: "st2"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "st16",
    points: "86.3,84.8 86.2,84.7 84.5,85.7 84.6,85.8  "
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "st46",
    points: "86.3,82.7 86.2,82.6 86.2,84.7 86.3,84.8  "
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "st16",
    points: "84.4,85.9 84.3,85.9 82.5,86.9 82.7,86.9  "
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "st46",
    points: "84.4,83.8 84.3,83.7 84.3,85.9 84.4,85.9  "
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "st16",
    points: "86.3,82.4 86.2,82.4 84.5,83.4 84.6,83.4  "
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "st46",
    points: "86.3,80.3 86.2,80.3 86.2,82.4 86.3,82.4  "
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "st16",
    points: "82.4,87 82.3,87 80.6,88 80.7,88  "
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "st46",
    points: "82.4,84.9 82.3,84.9 82.3,87 82.4,87  "
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "st16",
    points: "84.4,83.6 84.3,83.5 82.5,84.5 82.6,84.6  "
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "st46",
    points: "84.4,81.4 84.3,81.4 84.3,83.5 84.4,83.6  "
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "st16",
    points: "86.3,80.1 86.2,80 84.5,81 84.6,81.1  "
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "st46",
    points: "86.3,78 86.2,77.9 86.2,80 86.3,80.1  "
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "st16",
    points: "82.4,84.7 82.3,84.6 80.6,85.6 80.7,85.7  "
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "st46",
    points: "82.4,82.6 82.3,82.5 82.3,84.6 82.4,84.7  "
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "st16",
    points: "84.4,81.2 84.3,81.1 82.5,82.1 82.6,82.2  "
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "st46",
    points: "84.4,79.1 84.3,79 84.3,81.1 84.4,81.2  "
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "st16",
    points: "86.3,77.7 86.2,77.7 84.5,78.7 84.6,78.7  "
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "st46",
    points: "86.3,75.6 86.2,75.6 86.2,77.7 86.3,77.7  "
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "st16",
    points: "82.4,82.3 82.3,82.3 80.6,83.3 80.7,83.3  "
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "st46",
    points: "82.4,80.2 82.3,80.1 82.3,82.3 82.4,82.3  "
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "st16",
    points: "84.4,78.8 84.2,78.8 82.5,79.8 82.6,79.8  "
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "st46",
    points: "84.3,76.7 84.2,76.7 84.2,78.8 84.4,78.8  "
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "st16",
    points: "82.4,80 82.3,79.9 80.6,80.9 80.7,81  "
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "st46",
    points: "82.4,77.8 82.3,77.8 82.3,79.9 82.4,80  "
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "st16",
    points: "80.5,78.7 80.4,78.7 80.4,88.3 80.5,88.4  "
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "st16",
    points: "86.5,75.2 86.4,75.2 80.4,78.7 80.5,78.7  "
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st65",
    d: "M86.5,84.9l-6,3.5l0-9.7l6-3.5L86.5,84.9z M84.6,81.1l1.7-1l0-2.1l-1.7,1L84.6,81.1L84.6,81.1z  M82.6,82.2l1.7-1l0-2.1l-1.7,1L82.6,82.2L82.6,82.2z M80.7,83.3l1.7-1l0-2.1l-1.7,1L80.7,83.3L80.7,83.3z M84.6,85.8l1.7-1 l0-2.1l-1.7,1L84.6,85.8L84.6,85.8z M82.7,86.9l1.7-1l0-2.1l-1.7,1L82.7,86.9L82.7,86.9z M80.7,88l1.7-1l0-2.1l-1.7,1L80.7,88 L80.7,88z M82.6,79.8l1.7-1l0-2.1l-1.7,1L82.6,79.8L82.6,79.8z M82.6,84.6l1.7-1l0-2.1l-1.7,1L82.6,84.6L82.6,84.6z M84.6,83.4 l1.7-1l0-2.1l-1.7,1L84.6,83.4L84.6,83.4z M84.6,78.7l1.7-1l0-2.1l-1.7,1L84.6,78.7L84.6,78.7z M80.7,81l1.7-1l0-2.1l-1.7,1 L80.7,81L80.7,81z M80.7,85.7l1.7-1l0-2.1l-1.7,1L80.7,85.7L80.7,85.7z"
  })))))), _g13 || (_g13 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "st29",
    points: "93,76.8 92.2,77.1 92.2,76.9 93.1,76.5  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st29",
    points: "94.1,76.3 93.3,76.7 93.3,76.4 94.1,76  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st29",
    points: "93.6,76.9 92.7,77.2 92.8,77 93.6,76.6  "
  }))), _g14 || (_g14 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "st29",
    points: "97.2,80.2 96,80.9 96,80.4 97.2,79.7  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st29",
    points: "98.8,79.3 97.6,80 97.6,79.5 98.8,78.8  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st29",
    points: "92.5,80.1 91.3,80.8 91.3,80.3 92.5,79.6  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st29",
    points: "96,70 94.8,70.7 94.8,70.1 96,69.4  "
  })))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", {
    className: "st2"
  }, _g15 || (_g15 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "st29",
    points: "77.6,79.6 77.6,88.5 70.3,92.7 70.3,83.8  "
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("radialGradient", {
    id: "SVGID_00000116946309466104275250000007021333501342198965_",
    cx: 63.9858,
    cy: 84.5521,
    r: 7.299,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#009CCD"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.86,
    style: {
      stopColor: "#0085B5"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#0081B1"
    }
  })), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "url(#SVGID_00000116946309466104275250000007021333501342198965_)"
    },
    points: "70.3,83.8 70.3,92.7  57.6,85.3 57.6,76.4  "
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("radialGradient", {
    id: "SVGID_00000044137456712862371540000005903049992526647214_",
    cx: 67.589,
    cy: 78.0042,
    r: 8.143,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#009CCD"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.86,
    style: {
      stopColor: "#0085B5"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#0081B1"
    }
  })), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "url(#SVGID_00000044137456712862371540000005903049992526647214_)"
    },
    points: "77.6,79.6 70.3,83.8  57.6,76.4 64.8,72.2  "
  }), _g16 || (_g16 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "st29",
    points: "64.8,73.2 64.8,79.6 70.3,82.8 74.9,80.1 75.8,79.6  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st29",
    points: "59.4,76.4 60.2,76.9 64.8,79.6 64.8,73.2  "
  }))), /*#__PURE__*/React.createElement("radialGradient", {
    id: "SVGID_00000086655536960304105830000008893448845050596227_",
    cx: 67.5891,
    cy: 78.5098,
    r: 6.005,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#009CCD"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.86,
    style: {
      stopColor: "#0085B5"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#0081B1"
    }
  })), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "url(#SVGID_00000086655536960304105830000008893448845050596227_)"
    },
    points: "74.9,80.1 70.3,82.8  60.2,76.9 64.8,74.3  "
  })))), _g17 || (_g17 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "st35",
    points: "58.3,80.4 61.5,82.2 61.5,81.7 61.5,79.8 58.8,78.2 58.7,78.3 58.3,78.5  "
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "st48",
    points: "58.3,80.4 58.8,80.1 58.8,78.2 58.3,78  "
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "st47",
    points: "58.3,80.4 61.5,82.2 61.5,81.7 58.8,80.1  "
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "st35",
    points: "62.3,82.7 65.5,84.5 65.5,84 65.5,82.1 62.8,80.5 62.7,80.6 62.3,80.8  "
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "st48",
    points: "62.3,82.7 62.7,82.4 62.8,80.5 62.3,80.3  "
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "st47",
    points: "62.3,82.7 65.5,84.5 65.5,84 62.7,82.4  "
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "st35",
    points: "66.1,84.9 69.3,86.7 69.4,86.2 69.4,84.3 66.6,82.7 66.5,82.8 66.1,83  "
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "st48",
    points: "66.1,84.9 66.6,84.6 66.6,82.7 66.1,82.5  "
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "st47",
    points: "66.1,84.9 69.3,86.7 69.4,86.2 66.6,84.6  "
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "st35",
    points: "66.1,89.2 69.3,91 69.4,90.5 69.4,88.6 66.6,87 66.5,87 66.1,87.3  "
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "st48",
    points: "66.1,89.2 66.6,88.9 66.6,87 66.1,86.7  "
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "st47",
    points: "66.1,89.2 69.3,91 69.4,90.5 66.6,88.9  "
  }))))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("radialGradient", {
    id: "SVGID_00000168094224260271390780000010565188734715944612_",
    cx: 76.1311,
    cy: 81.5663,
    r: 0.6225,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#009CCD"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.86,
    style: {
      stopColor: "#0085B5"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#0081B1"
    }
  })), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "url(#SVGID_00000168094224260271390780000010565188734715944612_)"
    },
    points: "76.7,81.5 75.5,82.2 75.5,81.6  76.7,80.9  "
  }), /*#__PURE__*/React.createElement("radialGradient", {
    id: "SVGID_00000019643212776725325420000011020070043433068723_",
    cx: 75.4224,
    cy: 82.8307,
    r: 0.6225,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#009CCD"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.86,
    style: {
      stopColor: "#0085B5"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#0081B1"
    }
  })), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "url(#SVGID_00000019643212776725325420000011020070043433068723_)"
    },
    points: "76,82.8 74.8,83.5 74.8,82.9  76,82.2  "
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("radialGradient", {
    id: "SVGID_00000103267057179108550510000008032313268421465482_",
    cx: 71.9871,
    cy: 89.6593,
    r: 0.6225,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#009CCD"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.86,
    style: {
      stopColor: "#0085B5"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#0081B1"
    }
  })), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "url(#SVGID_00000103267057179108550510000008032313268421465482_)"
    },
    points: "72.6,89.6 71.4,90.3 71.4,89.7  72.6,89  "
  }), /*#__PURE__*/React.createElement("radialGradient", {
    id: "SVGID_00000134931430961822948320000018022547641345770893_",
    cx: 73.5602,
    cy: 88.7511,
    r: 0.6225,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#009CCD"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.86,
    style: {
      stopColor: "#0085B5"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#0081B1"
    }
  })), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "url(#SVGID_00000134931430961822948320000018022547641345770893_)"
    },
    points: "74.2,88.7 73,89.4 73,88.8  74.2,88.1  "
  }), /*#__PURE__*/React.createElement("radialGradient", {
    id: "SVGID_00000089542369411415212390000011153033338424308921_",
    cx: 72.8515,
    cy: 90.0155,
    r: 0.6225,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#009CCD"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.86,
    style: {
      stopColor: "#0085B5"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#0081B1"
    }
  })), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "url(#SVGID_00000089542369411415212390000011153033338424308921_)"
    },
    points: "73.5,90 72.2,90.7 72.2,90.1  73.5,89.4  "
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, _g18 || (_g18 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "st19",
    points: "61.5,85.2 61.5,92.5 54,96.9 54,89.5  "
  }))), _g19 || (_g19 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "st38",
    points: "54,89.5 54,96.9 40.8,89.3 40.8,81.9 44.1,83.8 44.4,84 45.1,84.4 45.5,84.6 48.4,86.3 49.3,86.8  49.4,86.8 50.3,87.4  "
  }))), _polygon36 || (_polygon36 = /*#__PURE__*/React.createElement("polygon", {
    className: "st16",
    points: "45.5,84.6 45.5,90.9 44.4,90.3 44.4,84 45.1,84.4  "
  })), _polygon37 || (_polygon37 = /*#__PURE__*/React.createElement("polygon", {
    className: "st16",
    points: "50.3,87.4 50.3,94 49.3,93.4 49.3,86.8 49.4,86.8  "
  })), _g20 || (_g20 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "st20",
    points: "61.5,85.2 54,89.5 40.8,81.9 48.3,77.6  "
  }))), _g21 || (_g21 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "st74",
    points: "59.8,89 59,91.1 60.7,90.1  "
  }), /*#__PURE__*/React.createElement("path", {
    className: "st75",
    d: "M59.8,89.2l0.7,0.9l-1.4,0.8L59.8,89.2L59.8,89.2z M59.8,89.1L59.1,91l1.5-0.9L59.8,89.1L59.8,89.1z"
  })), /*#__PURE__*/React.createElement("polygon", {
    className: "st75",
    points: "59.9,89.3 59.8,89.9 60.1,89.7 59.8,90.5 59.9,89.9 59.6,90.1  "
  }))), _g22 || (_g22 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "st74",
    points: "43.7,87.3 44.2,88.5 43.2,88  "
  }), /*#__PURE__*/React.createElement("path", {
    className: "st75",
    d: "M43.7,87.5l0.4,0.9L43.3,88L43.7,87.5L43.7,87.5z M43.7,87.4L43.2,88l0.9,0.5L43.7,87.4L43.7,87.4z"
  })), /*#__PURE__*/React.createElement("polygon", {
    className: "st75",
    points: "43.6,87.5 43.7,87.8 43.5,87.7 43.7,88.2 43.6,87.9 43.8,88  "
  }))), _g23 || (_g23 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "st74",
    points: "48.6,90.3 49.1,91.5 48.2,90.9  "
  }), /*#__PURE__*/React.createElement("path", {
    className: "st75",
    d: "M48.6,90.4l0.4,0.9l-0.8-0.5L48.6,90.4L48.6,90.4z M48.6,90.3l-0.4,0.6l0.9,0.5L48.6,90.3L48.6,90.3z"
  })), /*#__PURE__*/React.createElement("polygon", {
    className: "st75",
    points: "48.6,90.5 48.7,90.8 48.5,90.7 48.7,91.1 48.6,90.8 48.8,90.9  "
  }))), _g24 || (_g24 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "st74",
    points: "53.2,93 53.7,94.1 52.8,93.6  "
  }), /*#__PURE__*/React.createElement("path", {
    className: "st75",
    d: "M53.2,93.1l0.4,0.9l-0.8-0.5L53.2,93.1L53.2,93.1z M53.2,93l-0.4,0.6l0.9,0.5L53.2,93L53.2,93z"
  })), /*#__PURE__*/React.createElement("polygon", {
    className: "st75",
    points: "53.2,93.1 53.3,93.5 53.1,93.3 53.3,93.8 53.2,93.5 53.4,93.6  "
  }))), /*#__PURE__*/React.createElement("g", null, _g25 || (_g25 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "st29",
    points: "61.5,90.2 61.5,92.5 54,96.9 54,94.6  "
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("radialGradient", {
    id: "SVGID_00000005233712190214591680000004781181381179030687_",
    cx: 47.4073,
    cy: 91.913,
    r: 5.854,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#009CCD"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.86,
    style: {
      stopColor: "#0085B5"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#0081B1"
    }
  })), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "url(#SVGID_00000005233712190214591680000004781181381179030687_)"
    },
    points: "54,94.6 54,96.9 50.3,94.8  49.3,94.2 45.5,92 44.4,91.4 40.8,89.3 40.8,86.9 44.4,89 45.5,89.6 49.3,91.8 50.3,92.4  "
  })))), _polygon38 || (_polygon38 = /*#__PURE__*/React.createElement("polygon", {
    className: "st29",
    points: "45.5,89.6 45.5,92 44.4,91.4 44.4,89  "
  })), _polygon39 || (_polygon39 = /*#__PURE__*/React.createElement("polygon", {
    className: "st29",
    points: "50.3,92.4 50.3,94.8 49.3,94.2 49.3,91.8  "
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgHome);
export default __webpack_public_path__ + "static/media/home.437d62b679270402e39fc89bbc9bee66.svg";
export { ForwardRef as ReactComponent };